import { observable, action } from 'mobx';

class GiftCardUIState {
  @observable isGCSuccessMessageVisible = false;

  @observable isGCErrorMessageVisible = false;

  @observable isGCRemovedMessageVisible = false;

  @action
  showGiftCardSuccessMessage(): void {
    this.isGCSuccessMessageVisible = true;
  }

  @action
  showGiftCardErrorMessage(): void {
    this.isGCErrorMessageVisible = true;
  }

  @action
  showGiftCardRemovedMessage(): void {
    this.isGCRemovedMessageVisible = true;
  }

  @action
  resetGiftCardMessages(): void {
    this.isGCSuccessMessageVisible = false;
    this.isGCErrorMessageVisible = false;
    this.isGCRemovedMessageVisible = false;
  }
}

export default GiftCardUIState;
